<!--
 * @Description: 商机表单卡片
 * @Author: mdb
 * @Date: 2022-07-01 16:10:071
 * @LastEditTime: 2023-04-03 11:22:37
 * @LastEditors: cxh
-->
<template>
  <a-form scrollToFirstError>
    <dc-layout-card :title="props.title" :span="6">
      <dc-form-item :label="t('business.7y5c89')" v-bind="validateInfos.saleChanceRefId">
        <ClueAndCustomerSelect
          appId="cos_ofbu"
          v-model:value="dataForm.saleChanceRefId"
          v-model:label="dataForm.customerName"
          :disabled="!isEdit || props.saleChanceRefId"
          :view="props.type === 'view'"
          @change="handleCustomerNameChange"
        />
      </dc-form-item>
      <dc-form-item :label="t('business.nnrhea')" v-bind="validateInfos.arkCodeId">
        <GcCodeSelect
          :cosId="dataForm.saleChanceRefId"
          v-model:label="dataForm.arkCode"
          v-model:value="dataForm.arkCodeId"
          v-model:isEmpty="isEmptyCustomer"
          :disabled="!isEdit || props.arkCodeId"
          :view="props.type === 'view'"
          allowClear
          appId="cos_ofbu"
        />
      </dc-form-item>
      <dc-form-item :label="t('business.7xsihs')" v-bind="validateInfos.status">
        <template #label>
          {{ t('business.7xsihs') }}
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <div v-for="item in businessStatusEnumFilter" :key="item.value">
                <p>{{ item.label }}{{ item.desc ? `：${t(item.descLang)}` : '' }}</p>
              </div>
            </template>
            <ExclamationCircleOutlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSelect
          v-model:value="dataForm.status"
          :options="businessStatusEnumFilter"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item :label="t('business.me6p1g')" v-bind="validateInfos.headDestinationCountryWarehouse">
        <ParamCodesSelect
          v-model:value="dataForm.headDestinationCountryWarehouse"
          :options="paramCodeData.ofbu_demand_info"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('business.u21f2s')">
        <CosInput v-model:value="dataForm.id" view/>
      </dc-form-item>
      <dc-form-item v-if="props.type === 'view'" :label="t('common.createTime')">
        <CosInput v-model:value="dataForm.createTime" view/>
      </dc-form-item>
      <a-col :span="6" v-if="props.type !== 'view'">
        <div class="flex cos-both-form-item">
          <a-form-item style="width: 70%" :label="t('business.kolh0f')" v-bind="validateInfos.planSaleAmount">
            <CosInputNumber
              v-model:value="dataForm.planSaleAmount"
              :maxlength="15"
              :min="0"
              :controls="false"
              :placeholder="t('business.wsz78k')"
              :formatter="(value:string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value:string) => value.replace(/\$\s?|(,*)/g, '')"
            />
          </a-form-item>
          <a-form-item label="currency" style="width: 30%" v-bind="validateInfos.currency" class="hide-label">
            <ParamCodesSelect
              :options="paramCodeData.ofbu_currency"
              v-model:value="dataForm.currency"
              :allowClear="false"
            />
          </a-form-item>
        </div>
      </a-col>
      <dc-form-item v-else :label="t('business.kolh0f')" v-bind="validateInfos.planSaleAmount">
        <ParamCodesSelect
          :cosBeforeDes="dataForm.planSaleAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.currency"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <dc-form-item
        :label="t('business.t3fsg4')"
        name="shipments"
      >
        <ParamCodesSelect
          v-model:value="dataForm.shipments"
          :options="paramCodeData.ofbu_shipments"
          :disabled="!isEdit"
          :view="props.type === 'view'"
          allowClear
        />
      </dc-form-item>
      <a-col :span="24" />
      <dc-form-item :label="t('common.remark')" :span="12">
        <CosTextarea
          v-model:value="dataForm.remark"
          :maxlength="2000"
          :disabled="!isEdit"
          :view="props.type === 'view'"
        />
      </dc-form-item>
      <!-- <dc-form-item :label="t('business.kolh0f')" v-bind="validateInfos.planSaleAmount">
        <CosInputNumber
          style="width: 100%"
          :min="0"
          :maxlength="15"
          v-model:value="dataForm.planSaleAmount"
          :disabled="!isEdit"
          :placeholder="t('business.wsz78k')"
          :view="props.type === 'view'"
        />
      </dc-form-item> -->
    </dc-layout-card>
    <dc-layout-card :title="t('business.23f4y5')" :span="6">
<!--      <a-col :span="6" v-if="props.type !== 'view'">-->
<!--        <div class="flex cos-both-form-item">-->
<!--          <a-form-item style="width: 70%" :label="t('business.tw4fv1')">-->
<!--            <CosInputNumber-->
<!--              v-model:value="dataForm.avgMonthlySales"-->
<!--              :maxlength="15"-->
<!--              :min="0"-->
<!--              disabled-->
<!--              :controls="false"-->
<!--              :formatter="(value:string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"-->
<!--              :parser="(value:string) => value.replace(/\$\s?|(,*)/g, '')"-->
<!--            />-->
<!--          </a-form-item>-->
<!--          <a-form-item label="currency" style="width: 30%" class="hide-label">-->
<!--            <ParamCodesSelect-->
<!--              :options="paramCodeData.ofbu_currency"-->
<!--              disabled-->
<!--              v-model:value="dataForm.avgMonthlySalesCurrency"-->
<!--              :allowClear="false"-->
<!--            />-->
<!--          </a-form-item>-->
<!--        </div>-->
<!--      </a-col>-->
      <dc-form-item :label="t('business.tw4fv1')">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('business.tw4fv1Desc')}}</p>
            </template>
            <span>{{t('business.tw4fv1')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <ParamCodesSelect
          :cosBeforeDes="dataForm.avgMonthlySales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :options="paramCodeData.ofbu_currency"
          v-model:value="dataForm.avgMonthlySalesCurrency"
          disabled
          view
        />
      </dc-form-item>
      <dc-form-item :label="t('business.ts2f2s')">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('business.ts2f2sDesc')}}</p>
            </template>
            <span>{{t('business.ts2f2s')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosInput v-model:value="dataForm.avgMonthlyOrder" disabled view />
      </dc-form-item>
      <dc-form-item :label="t('business.sj39ks')" >
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('business.sj39ksDesc')}}</p>
            </template>
            <span>{{t('business.sj39ks')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="dataForm.firstInboundDate"
          :isRange="false"
          disabled
          view
        />
      </dc-form-item>
      <dc-form-item :label="t('business.sasd32')">
        <template #label>
          <a-tooltip placement="topLeft" :overlayStyle="{ maxWidth: '800px' }">
            <template #title>
              <p>{{t('business.sasd32Desc')}}</p>
            </template>
            <span>{{t('business.sasd32')}}</span>
            <exclamation-circle-outlined style="margin-left: 2px; font-size: 14px" />
          </a-tooltip>
        </template>
        <CosSingleDateTimePicker
          isOutputBeijingTime
          v-model:startTime="dataForm.firstTransactionDate"
          :isRange="false"
          disabled
          view
        />
      </dc-form-item>
    </dc-layout-card>
  </a-form>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, watch, watchEffect, toRaw, computed } from 'vue'
import { cloneDeep, isEqual } from 'lodash-es'
import { useI18n } from 'vue-i18n'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import GcCodeSelect from '@/components/GcCodeSelect'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { Form } from 'ant-design-vue'
import { businessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { SelectProps } from 'ant-design-vue'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import CosInput from '@/components/Antd/CosInput/index.vue'
const useForm = Form.useForm
const { t } = useI18n()

const props = defineProps<{
  value: { [key: string]: any }
  title?: string
  type: 'add' | 'edit' | 'view'
  saleChanceRefId?: boolean
  arkCodeId?: boolean
  isFromPotentialCustomer?: boolean
}>()

const businessStatusEnumFilter = computed(() => {
  return businessStatusEnum.map((item) => ({ ...item, disabled: props.type === 'add' && item.value === 5 }))
})
const isEdit = computed(() => props.type !== 'view')
const logisticsProductsEnum = ref<SelectProps['options']>([])
const paramCodeData = ref<{
  ofbu_demand_info: ParamCodeItem[]
  ofbu_currency: ParamCodeItem[]
  ofbu_shipments: ParamCodeItem[]
}>({
  ofbu_demand_info: [], // 区域仓(需求海外仓参数)
  ofbu_currency: [], // 币种
  ofbu_shipments: [] // 发货量
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_demand_info',
      'ofbu_currency',
      'ofbu_shipments'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())

const dataForm = reactive<FbuBusinessEditParams>({
  customerName: undefined,
  saleChanceRefId: undefined,
  arkCodeId: undefined,
  planSaleAmount: undefined,
  currency: undefined,
  status: undefined,
  remark: undefined,
  chanceType: undefined,
  orderType: 2,
  planSignTime: undefined,
  headDomesticWarehouse: undefined,
  headDestinationCountryWarehouse: undefined,
  headTransportMode: undefined,
  headCompetitors: undefined,
  tailWarehouse: undefined,
  tailProductName: undefined,
  tailCompetitors: undefined
})

const emit = defineEmits(['update:value'])

watch(
  () => props.value,
  (val) => {
    if (!val) return
    // 如果值相同则不更新
    const isSame = isEqual(toRaw(dataForm), toRaw(val))
    if (isSame) return
    const clone = cloneDeep(val)
    Object.assign(dataForm, clone)
    if (props.type === 'view') {
      setTimeout(() => clearValidate())
    }
  },
  { deep: true, immediate: true }
)
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)

const isRequiredCustomer = ref<boolean>()
const isEmptyCustomer = ref<boolean>()

// 监听是否转潜在客户(客户代码非必填)
// 监听有客户代码数据时则必选
const isFromPotentialCustomer = computed(() => props.isFromPotentialCustomer)
watch(
  [isFromPotentialCustomer, isEmptyCustomer],
  ([isFromPotential, isEmptyCustomer]) => {
    if (isFromPotential || isEmptyCustomer) {
      isRequiredCustomer.value = false
    } else {
      isRequiredCustomer.value = true
    }
    if (props.type === 'edit' || props.type === 'view') {
      setTimeout(() => clearValidate(['arkCodeId']), 0)
    }
  },
  { immediate: true }
)
const handleCustomerNameChange = (val: any) => {
  dataForm.shipments = undefined
  dataForm.planSaleAmount = undefined
  dataForm.currency = undefined
  potentialDetail(val)
    .then((res) => {
      if (res.data?.business) {
        if (res.data.business.shipments) {
          dataForm.shipments = res.data.business.shipments
        }
        if (res.data.business.annualSales) {
          dataForm.planSaleAmount = res.data.business.annualSales
        }
        if (res.data.business.annualSalesUnit) {
          dataForm.currency = res.data.business.annualSalesUnit
        }
      }
    })
  setTimeout(() => clearValidate(['arkCodeId']), 0)
  setTimeout(() => clearValidate(['planSaleAmount']), 0)
  setTimeout(() => clearValidate(['currency']), 0)
}
const formRules = computed(() => ({
  saleChanceRefId: [{ required: true, message: t('common.pleaseSelect') }],
  arkCodeId: [{ required: true, message: t('common.pleaseSelect') }],
  planSaleAmount: [{ required: true, message: t('common.pleaseInput') }],
  currency: [{ required: true, message: t('common.pleaseSelect') }],
  status: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  headDestinationCountryWarehouse: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }]
}))
const { resetFields, validate, validateInfos, clearValidate } = useForm(dataForm, formRules)

defineExpose({ resetFields, validate, clearValidate })
</script>
<script lang="ts">
export default { name: 'BusinessForm' }
</script>

<style scoped></style>
